import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {UncontrolledTooltip} from 'reactstrap'
import './styles.css'
import { useTranslation } from 'react-i18next';

function BlockActBtn({isBlock= false, action= () => {}, className, color='#106AD4', fs= '12px', style={}, tooltip='asfasfadfafafasdf'}) {
    
    const { t } = useTranslation();
    return (
        <div className='BlockActBtnCont justify-content-center align-items-center' style={style}>
        <FontAwesomeIcon color={isBlock ? '#7E96AE': color  } className='mr-1' icon={isBlock ? 'lock': 'lock-open'} ></FontAwesomeIcon>
        <button id={tooltip} onClick={action} type='button' className={`${className} `} style={{backgroundColor: isBlock ? '#7E96AE': color  }}>
            <div className='circleBlockActBtn' style={{left: isBlock? '0': '10px' }} />
        </button>
        {tooltip!=='asfasfadfafafasdf' && <UncontrolledTooltip className='blockMsgTooltip' onClick={()=>{debugger}} autohide={false} placement='bottom' target={tooltip} style={{top:'5px'}}>
                <div style={{fontSize: '10px'}}>
                {t('blockMsg')} 
                </div>
            </UncontrolledTooltip>}
        </div>
    )
}
/*
        <button onClick={action} type='button' className={`${className} BlockActBtnCont`} style={{width: diametro, height: diametro, fontSize: fs, color: isFav ? '#106AD4' : '#8797A7' }}>
            <FontAwesomeIcon icon={isFav? 'heart' : ['far', 'heart'] }></FontAwesomeIcon>
        </button>
*/
export default BlockActBtn
